import React from 'react'

import {
    useHistory
} from "react-router-dom"

import { 
    useForm 
} from 'react-hook-form'

import { 
    API,
    Auth 
} from 'aws-amplify'

import {
    formatPhoneNumberAWS
} from '../../Utilities/StringTools'

import { 
    ErrorText,
    BlueTint,
    RedTint 
} from '../../Styles/BaseStyles'

import { 
    SignUpDiv, 
    SignUpComponentsDiv, 
    SignUpFieldsDiv,
    QuickFillerButtonDiv,
    TitleIconButton,
    QuickFillerButton,
    SignUpTitle, 
    SignUpFormDiv, 
    SignUpRowDiv,
    FullSignUpDiv,
    SignUpHeader,
    SignUpInputField, 
    SignUpButtonDiv, 
    SignInButtonDiv, 
    QuestionDiv, 
    SignUpButton, 
    SignInButton, 
    QuestionPhrase 
} from '../../Styles/Components/SignUpFieldsStyles'

import { useDispatch } from 'react-redux'

import { accountCreated, accountCreationError } from '../../Redux/Slices/SignUpSlice'

function SignUpFields(props){
    const { register, errors, watch, handleSubmit } = useForm({
        validateCriteriaMode: "all",
        mode: "onChange"
    })

    const watchPassword = watch("password","")
    const watchCPassword = watch("cpassword","")

    const dispatch = useDispatch()

    let history = useHistory()

    function mainPage(e){
        history.push('/')
    }

    function loginTransition(){
        history.push('/login')
    }
    
    function formActions(data){
        signup(data);
    }

    async function signup(data) {
        var firstname = data.firstname
        var lastname = data.lastname
        var email = data.email;
        var pswd = data.password;
        var phoneno = data.phoneno;
        var formattedPhoneNo = formatPhoneNumberAWS(phoneno)
    
        try {
            const user = await Auth.signUp({
                username: email,
                password: pswd,
                attributes: {
                    phone_number: formattedPhoneNo,
                    'custom:firstname': firstname,
                    'custom:lastname': lastname
                }
            })
            const customer = await API.post('quickfillerapi','/create-customer',{
                body: {
                    email: email
                }
            })
            await API.post('quickfillerapi','/create-user',{
                body: {
                    id: user.userSub,
                    owner: user.userSub,
                    first_name: firstname,
                    last_name: lastname,
                    email: email,
                    phone_number: formattedPhoneNo,
                    stripe_id: customer.customer.id,
                    subscription_id: '',
                    subscription_status: '',
                    user_group: 'none'
                }
            })
            dispatch(accountCreated({email: email}))
        } catch (error) {
            switch(error.name){
                case 'UsernameExistsException':
                    dispatch(accountCreationError({errorPhrase: 'Account with the provided email already exists'}))
                    break
                default:
                    dispatch(accountCreationError({errorPhrase: 'Error during sign up'}))
                    break
            }
            console.log(error)
        }
    }

    return (
        <SignUpDiv id="signup-section">
            <SignUpComponentsDiv>
                <SignUpFieldsDiv>
                    <QuickFillerButtonDiv>
                        <TitleIconButton />
                        <QuickFillerButton onClick={mainPage}><BlueTint>Q</BlueTint>uick<BlueTint>F</BlueTint>iller</QuickFillerButton>
                    </QuickFillerButtonDiv>
                    <SignUpTitle>Sign up</SignUpTitle>
                    <SignUpFormDiv>
                        <form>
                            <SignUpRowDiv>
                                <FullSignUpDiv>
                                    <SignUpHeader>First Name<RedTint>*</RedTint></SignUpHeader>
                                    <SignUpInputField 
                                        type="text" name="firstname" placeholder="" 
                                        ref={
                                            register({ 
                                                required: {
                                                    value: true,
                                                    message: 'required field'
                                                },
                                                maxLength: {
                                                    value: 35,
                                                    message: 'exceeds 35 character limit'
                                                }, 
                                                pattern: {
                                                    value: /^[a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð' -]+$/u,
                                                    message: 'invalid character used'
                                                }
                                            })
                                        }
                                    /><br/>
                                    {errors.firstname && <ErrorText>*{errors.firstname.message}</ErrorText>}
                                </FullSignUpDiv>
                            </SignUpRowDiv>
                            <SignUpRowDiv>
                                <FullSignUpDiv>
                                    <SignUpHeader>Last Name<RedTint>*</RedTint></SignUpHeader>
                                    <SignUpInputField 
                                        type="text" name="lastname" placeholder="" 
                                        ref={
                                            register({ 
                                                required: {
                                                    value: true,
                                                    message: 'required field'
                                                }, 
                                                maxLength: {
                                                    value: 35,
                                                    message: 'exceeds 35 character limit'
                                                }, 
                                                pattern: {
                                                    value: /^[a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð' -]+$/u,
                                                    message: 'invalid character used'
                                                }
                                            })
                                        }
                                    />
                                    {errors.lastname && <ErrorText>*{errors.lastname.message}</ErrorText>}
                                </FullSignUpDiv>
                            </SignUpRowDiv>
                            <SignUpRowDiv>
                                <FullSignUpDiv>
                                    <SignUpHeader>Email<RedTint>*</RedTint></SignUpHeader>
                                    <SignUpInputField 
                                        type="text" name="email" placeholder="" 
                                        ref={
                                            register({ 
                                                required: {
                                                    value: true,
                                                    message: 'required field'
                                                }, 
                                                maxLength: {
                                                    value: 320,
                                                    message: 'exceeds 320 character limit'
                                                }, 
                                                pattern: {
                                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                    message: 'invalid format or character used'
                                                }
                                            })
                                        }
                                    /><br/>
                                    {errors.email && <ErrorText>*{errors.email.message}</ErrorText>}
                                </FullSignUpDiv>
                            </SignUpRowDiv>
                            <SignUpRowDiv>
                                <FullSignUpDiv>
                                    <SignUpHeader>Phone Number<RedTint>*</RedTint></SignUpHeader>
                                    <SignUpInputField 
                                        type="text" name="phoneno" placeholder="" 
                                        ref={
                                            register({ 
                                                required: {
                                                    value: true, 
                                                    message: 'required field'
                                                },
                                                maxLength: {
                                                    value: 20,
                                                    message: 'exceeds 20 character limit'
                                                },  
                                                pattern: {
                                                    value: /^((\+)?\d{1,2}[-\s\.]?)?\(?\d{3}\)?[-\s\.]?\d{3}[-\s\.]?\d{4}$/,
                                                    message: 'invalid format or character used'
                                                } 
                                            })
                                        }
                                    />
                                    {errors.phoneno && <ErrorText>*{errors.phoneno.message}</ErrorText>}
                                </FullSignUpDiv>
                            </SignUpRowDiv>
                            <SignUpRowDiv>
                                <FullSignUpDiv>
                                    <SignUpHeader>Password<RedTint>*</RedTint></SignUpHeader>
                                    <SignUpInputField 
                                        type="password" name="password" placeholder="" 
                                        ref={
                                            register({ 
                                                required: {
                                                    value: true,
                                                    message: 'required field'
                                                },
                                                minLength: {
                                                    value: 8,
                                                    message: 'below 8 character minimum'
                                                },
                                                maxLength: {
                                                    value: 128,
                                                    message: 'exceeds 128 character limit'
                                                },  
                                                pattern: {
                                                    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                                    message: 'must contain: 8 characters, uppercase letter, lowercase letter, number, and special character'
                                                } 
                                            })
                                        }
                                    />
                                    {errors.password && <ErrorText>*{errors.password.message}</ErrorText>}
                                </FullSignUpDiv>
                            </SignUpRowDiv>
                            <SignUpRowDiv>
                                <FullSignUpDiv>
                                    <SignUpHeader>Confirm Password<RedTint>*</RedTint></SignUpHeader>
                                    <SignUpInputField 
                                        type="password" name="cpassword" placeholder="" 
                                        ref={
                                            register({ 
                                                required: {
                                                    value: true,
                                                    message: 'required field'
                                                },
                                                minLength: {
                                                    value: 8,
                                                    message: 'below 8 character minimum'
                                                },
                                                maxLength: {
                                                    value: 128,
                                                    message: 'exceeds 128 character limit'
                                                },  
                                                pattern: {
                                                    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                                    message: 'must contain: 8 characters, uppercase letter, lowercase letter, number, and special character'
                                                } 
                                            })  
                                        }
                                    /><br/>
                                    {(errors.cpassword != null) && <ErrorText>*{errors.cpassword.message}</ErrorText>}
                                    {(errors.cpassword == null && !watchPassword===watchCPassword) && <ErrorText>*must match password</ErrorText>}
                                </FullSignUpDiv>
                            </SignUpRowDiv>
                            <SignUpButtonDiv>
                                <SignUpButton onClick={handleSubmit(formActions)}>Sign up</SignUpButton>
                            </SignUpButtonDiv>
                        </form>
                        <QuestionDiv>
                            <QuestionPhrase>Already have an account?</QuestionPhrase>
                        </QuestionDiv>
                        <SignInButtonDiv>
                            <SignInButton onClick={loginTransition}>Log in</SignInButton>
                        </SignInButtonDiv>
                    </SignUpFormDiv>
                </SignUpFieldsDiv>
            </SignUpComponentsDiv>
        </SignUpDiv>
    )
}

export default SignUpFields